export const currentProfileRoutes = [
  {
    path: '/current-profile',
    name: 'current-profile',
    component: () => import('@b2ag/micro-front-my-account/add-current-profile'),
    props: () => ({
      microFrontName: 'my-account',
      viewName: 'add-current-profile',
    }),
    meta: {
      private: true,
      layout: 'minimal',
    },
  },
]
